<template>
  <div class="content">
    <div class="content_banner">
      <img src="../assets/img/banner/banner_contact.jpg" alt="">
    </div>
    <h2 class="contact_tit">联系我们</h2>
    <div class="contact_map">
      <div class="contact_map_wrap" id="mapBox"></div>
      <div class="contact_cont">
        <div class="contact_cont_wrap">
          <div class="contact_cont_tit">甘肃省交通工程建设监理有限公司</div>
          <ul>
            <li>
              <h3>网址</h3>
              <p><a href="http://www.gsjtjl.com">http://www.gsjtjl.com</a></p>
            </li>
            <li>
              <h3>联系地址</h3>
              <p>兰州市城关区和平新村127号元富大厦7-8F</p>
            </li>
            <li>
              <h3>联系电话</h3>
              <p>0931-8615070</p>
            </li>
            <li>
              <h3>电子信箱</h3>
              <p>gsjtjl@163.com</p>
            </li>
            <li>
              <h3>邮政编码</h3>
              <p>730030</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'contact',
  data(){
    return{
      total: 25,
      currentPage: 1
    }
  },
  mounted: function(){
    var _this = this

    setTimeout(function(){
      _this.createMap();
    },1000)
  },
  methods: {
    createMap() {
      var _this = this;
      var map = new window.AMap.Map("mapBox", {
        // mapStyle: 'amap://styles/whitesmoke',
        resizeEnable: true,
        zoomEnable:false,
        dragEnable: false,
        // zoom: 11,
        center: [104.141485,36.036796]
      });

      _this.createMapPosition(map);

    },
    createMapPosition(map) {
      var _this = this;
      var infoWindow = new window.AMap.InfoWindow({offset: new window.AMap.Pixel(0, -30)});
      var positionList = [{
        position: [103.83301,36.035338],
        info: "甘肃省兰州市城关区和平新村127号7F"
      }];
      for(var i = 0; i < positionList.length; i++){
        var marker = new window.AMap.Marker({
            map: map,
            position: positionList[i].position
        });
        marker.setIcon(_this.icon)
        marker.content = positionList[i].info;
        marker.on('click', function(e){
          infoWindow.setContent(e.target.content);
          infoWindow.open(map, e.target.getPosition());
        });
        marker.setAnimation('AMAP_ANIMATION_BOUNCE');
        // marker.emit('click', {target: marker});
      }
    },
  }
}
</script>
<style scoped>
  .contact_map {
    height: 560px;
    position: relative;
  }
  .contact_map_wrap {
    height: 100%;
  }
  .contact_tit {
    line-height: 150px;
    font-size: 30px;
    text-align: center;
  }
  .contact_cont {
    position: absolute;
    width: 50%;
    height: 100%;
    top: 0;
    right: 0;
    background-color: rgba(255, 255, 255, 0.9);
  }
  .contact_cont_tit {
    font-size: 24px;
    margin-bottom: 20px;
    color: #000;
  }
  .contact_cont_wrap {
    position: absolute;
    left: 8%;
    top: 50%;
    transform: translateY(-50%);
  }
  .contact_cont_wrap ul li {
    margin: 15px 0;
  }
  .contact_cont_wrap ul li h3 {
    line-height: 30px;
    font-size: 18px;
    color: #333;
  }
  .contact_cont_wrap ul li p {
    color: #666;
    line-height: 26px;
  }
  .contact_cont_wrap ul li p a {
    color: #666;
  }
</style>